module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-756-retro.436ee58f.jpg";